import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import 'whatwg-fetch';

export const saveSettings = createAsyncThunk('settings/save', async (settings, { getState }) => {
    const params = new URLSearchParams(window.location.search);
    const { site_id } = getState().auth.data;
    try {
        const resp = await fetch(`${process.env.API_URL}/settings/save`, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                signed_payload: params.get('signed_payload'),
                settings,
                site_id,
            }),
        }).then(resp => resp.json());
    
        if (resp && resp.success) {
            return resp.data;
        }
    } catch (e) {
        console.error(e);
    }
});

const settingsSlice = createSlice({
    name: 'settings',
    initialState: {
        data: {},
        saving: 'idle',
        defaults: {},
    },
    reducers: {
        loadSettings(state, action) {
            state.data = action.payload || {};
        },
        loadDefaultSettings(state, action) {
            state.defaults = action.payload || {};
        },
    },
    extraReducers: {
        [saveSettings.pending]: (state) => {
            state.saving = 'pending';
        },
        [saveSettings.fulfilled]: (state, action) => {
            state.saving = 'idle';
            state.data = action.payload;
        },
    }
});

export const { loadSettings, loadDefaultSettings } = settingsSlice.actions;

export default settingsSlice.reducer;